'use client'

import cx from 'classnames'
import Link from 'next/link'
import { useState } from 'react'
import { FOOTER_SECTIONS } from '../footer-data'
import s from './footer-nav.module.scss'

export const FooterNav = () => {
  const [openId, setOpenId] = useState<string | null>(null)

  const toggle = (id: string) => {
    setOpenId((prev) => (prev === id ? null : id))
  }

  return (
    <div className={s.nav}>
      {FOOTER_SECTIONS.map((section) => {
        const panelId = `footer-panel-${section.id}`
        const isOpen = openId === section.id

        return (
          <section key={section.id} className={s.section}>
            <h3 className={s.heading}>
              <button
                type="button"
                aria-expanded={isOpen}
                aria-controls={panelId}
                onClick={() => toggle(section.id)}
                className={s.toggle}
              >
                <span>{section.heading}</span>
                <svg
                  className={cx(s.chevron, { [s.chevronOpen]: isOpen })}
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  aria-hidden="true"
                >
                  <path
                    d="M4 6L8 10L12 6"
                    stroke="#fff"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </h3>
            <ul
              id={panelId}
              className={s.panel}
              data-open={isOpen}
            >
              {section.links.map((link) => (
                <li key={link.href} className={s.linkItem}>
                  <Link
                    href={link.href}
                    className={s.link}
                    {...(link.external && {
                      target: '_blank',
                      rel: 'noreferrer noopener',
                    })}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </section>
        )
      })}
    </div>
  )
}
